import { gql } from "@apollo/client";
import { EMPLOYMENTS_FRAGMENT } from "../fragments";

export const ADD_EMPLOYMENT_QUERY = gql`
  query availableJobTitles {
    availableJobTitles {
      id
      jobTitle
      jobClassification
    }
    currentPerson {
      id
      ...EmploymentsFragment
    }
  }
  ${EMPLOYMENTS_FRAGMENT}
`;

export const CHANGE_EMPLOYMENT_MUTATION = gql`
  mutation changeEmployment($input: MembershipChangeEmploymentInput!) {
    changeEmployment(input: $input) {
      success
      message
      status
    }
  }
`;
